import '@/styles/globals.css'
import '@/styles/site.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Manrope, Geist_Mono } from 'next/font/google'
import { Preloader } from '@/components/generals/preloader'
import { PageTransition } from '@/components/generals/page-transition'

const sans = Manrope({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Preloader />

            <Component {...pageProps} />

            <PageTransition />
        </div>
    )
}

export default App
